(function(register){
    if (document.readyState !== 'loading') {
        register();
    } else {
        document.addEventListener('DOMContentLoaded', register, {
            once: true,
            passive: true,
        });
    }
})(function() {
    if (customElements.get('base-simple-rating') === undefined) {
        const template = document.createElement('template');
        template.innerHTML = `<style>
        :host {
          --simple-rating-inner-margin: 1rem;
          --simple-rating-back-opacity: .25;
          display: inline-block;
          text-align: center;
        }
        [part="figure"] {
          margin: 0 0 var(--simple-rating-inner-margin);
          display: inline-block;
          position: relative;
        }
        [part="mask"] {
          position: relative;
          z-index: 1;
          white-space: nowrap;
          display: inline-block;
        }
        [part="back"] {
          position: absolute;
          z-index: 0;
          left: 0;
          top: 0;
          white-space: nowrap;
          opacity: var(--simple-rating-back-opacity);
        }
        [part="default-icon"] {
          font-size: 2rem;
          display: inline-block;
          line-height: 1;
          padding: 0 .25em;
          color: gold;
          filter: drop-shadow(1px 1px 0px rgba(0, 0, 0, .25));
        }
        [part="default-icon"]::before {
          font-family: sans-serif;
          content: '★';
        }
        [part="separator"]::before {
            content: " / "
        }
        </style>
        <figure part="figure">
            <div part="mask">
                <slot name="icon">
                    <span part="default-icon"></span>
                </slot>
            </div>
            <div part="back">
                <slot name="back-icon"></slot>
            </div>
        </figure>
        <div part="text">
            <slot><b part="value"></b><span part="separator"></span><span part="max"></span></slot>
        </div>`;
        // @todo check update
        customElements.define('base-simple-rating', class extends HTMLElement {

            static get observedAttributes() {
                return ['max', 'value'];
            }

            get max() {
                return Math.ceil(parseFloat(this.getAttribute('max')));
            }

            get value() {
                return parseFloat(this.getAttribute('value'));
            }

            set max(value) {
                this.setAttribute('max', value);
            }

            set value(value) {
                this.setAttribute('value', value);
            }

            get percentage() {
                if (this.max > 0) {
                    return Math.min(
                        100,
                        Math.max(
                            0,
                            this.value / this.max * 100
                        )
                    );
                }
                return 100;
            }

            constructor() {
                super();
                this.attachShadow({mode: "open"}).appendChild(template.content.cloneNode(true));
                this.defaultIcon = this.shadowRoot.querySelector('[part="default-icon"]').cloneNode(true);
                if (!this.hasAttribute('max')) {
                    if (this.hasAttribute('value')) {
                        this.max = Math.min(1, parseFloat(this.getAttribute('value')));
                    } else {
                        this.max = 5;
                    }
                }
                if (!this.hasAttribute('value')) {
                    this.value = this.max;
                }
                this.addEventListener('slotchange', () => {
                    this.storeIcon();
                })
            }
            connectedCallback() {
                this.storeIcon();
                this.update();
            }
            storeIcon() {
                const icon = this.querySelector('*[slot="icon"]');
                if (icon) {
                    this.slottedIcon = icon.cloneNode(true);
                }
            }
            update() {
                // update markup, need to replicate slotted icon x (attr-max) times and set width for mask
                this.shadowRoot.querySelector('[part="value"]').innerHTML = this.getAttribute('value');
                this.shadowRoot.querySelector('[part="max"]').innerHTML = this.getAttribute('max');
                if (this.slottedIcon) {
                    const icon = this.querySelector('*[slot="icon"]');
                    icon.parentNode.removeChild(icon);
                    let backIcon = this.querySelector('*[slot="back-icon"]');
                    if (backIcon) {
                        backIcon.parentNode.removeChild(backIcon);
                    }
                    const newIcon = this.slottedIcon.cloneNode(true);
                    const children = [];
                    Array.from(newIcon.childNodes).forEach(node => {
                        children.push(node.cloneNode(true));
                    });
                    for (let i = this.max; i > 1; i--) {
                        children.forEach(childNode => {
                            newIcon.appendChild(childNode.cloneNode(true));
                        });
                    }
                    this.appendChild(newIcon);
                    backIcon = newIcon.cloneNode(true);
                    backIcon.setAttribute('slot', 'back-icon');
                    this.appendChild(backIcon);
                } else {
                    const iconSlot = this.shadowRoot.querySelector('slot[name="icon"]');
                    const backIconSlot = this.shadowRoot.querySelector('slot[name="back-icon"]');
                    backIconSlot.innerHTML = "";
                    iconSlot.innerHTML = "";
                    for (let i = this.max; i > 0; i--) {
                        iconSlot.appendChild(this.defaultIcon.cloneNode(true));
                        backIconSlot.appendChild(this.defaultIcon.cloneNode(true));
                    }
                }
                this.shadowRoot.querySelector('[part="mask"]').style.clipPath = `inset(0 ${100 - this.percentage}% 0 0)`;
            }
            attributeChangedCallback(name, oldValue, newValue) {
                if (name === 'max' || name === 'value') {
                    this.update();
                }
            }
        });
    }
});
